// 2026-05-25 推薦中心 — 外殼
// 截圖一：page title「推薦中心」+ ONE 大白卡包住 tabs + 所有內容（區塊連在一起）
import { Routes, Route, useNavigate, useLocation, Navigate } from "react-router-dom";
import { useEffect, useContext, useMemo } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ReferralList from "./ReferralList";
import ReferralEarnings from "./ReferralEarnings";
import WithdrawalHistory from "./WithdrawalHistory";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { LanguageContext } from "../../../../context/LanguageContext";
import { COLORS, TYPO } from "theme/tokens";

export default function ReferralTabs() {
  const navigate = useNavigate();
  const location = useLocation();
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);
  useEffect(() => {
    loadLanguageFile("ReferralTabs", "referral/ReferralTabs/ReferralTabs_lang");
  }, [language]);
  const LANGUAGE = useMemo(
    () => componentLanguageData.ReferralTabs || { Main: {} },
    [componentLanguageData]
  );

  const tabMap = [
    { key: "list", path: "/referral/referralList", label: LANGUAGE.Main.Content1 || "推薦名單" },
    { key: "earnings", path: "/referral/referralEarnings", label: LANGUAGE.Main.Content2 || "推薦收益紀錄" },
    { key: "withdrawals", path: "/referral/referralWithdrawals", label: LANGUAGE.Main.WdTabHistory || "提領紀錄" },
  ];
  const currentTab = Math.max(
    0,
    tabMap.findIndex((t) => location.pathname.startsWith(t.path))
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox p={3} sx={{ background: COLORS.pageBg, minHeight: "100vh" }}>
        {/* page title */}
        <MDTypography sx={{ fontSize: "20px", fontWeight: 700, color: COLORS.black, mb: 2 }}>
          {LANGUAGE.Main.PageTitle || "推薦中心"}
        </MDTypography>

        {/* ONE 大白卡：tabs + 所有內容區塊連在一起 */}
        <Card sx={{ p: 3, borderRadius: 3, boxShadow: "0 4px 16px rgba(0,0,0,0.04)" }}>
          {/* tab 切換（選取：白底+陰影+黑字 / 未選：灰底+灰字）依 Sean 規格 */}
          <Box sx={{ display: "flex", gap: 1, mb: 3 }}>
            {tabMap.map((t, idx) => {
              const active = currentTab === idx;
              return (
                <Box
                  key={t.key}
                  onClick={() => navigate(t.path)}
                  sx={{
                    flex: "1 0 0",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    py: "12px",
                    px: "16px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    ...TYPO.title,
                    fontWeight: 700,
                    background: active ? COLORS.white : COLORS.grayLightest,
                    color: active ? COLORS.black : COLORS.grayMedian,
                    boxShadow: active ? "0 0 6px 0 rgba(0, 0, 0, 0.06)" : "none",
                    transition: "all 0.15s",
                  }}
                >
                  {t.label}
                </Box>
              );
            })}
          </Box>

          {/* tab content — 由子元件 render，子元件不再包外卡 */}
          <Routes>
            <Route path="*" element={<Navigate to="referralList" replace />} />
            <Route path="referralList" element={<ReferralList />} />
            <Route path="referralEarnings" element={<ReferralEarnings />} />
            <Route path="referralWithdrawals" element={<WithdrawalHistory />} />
          </Routes>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}
